import { getDefaultAttributes } from "core-lib/utils/events";
import { isStringValid } from "core-lib/utils/utils";

export enum PageSources {
  Organic = "organic",
}

export const getCommonOffenceAttributes = ({
  fromPageSource = null,
}: { fromPageSource?: string | null } = {}) => ({
  ...getDefaultAttributes(),
  category: "Offence",
  source_page: isStringValid(fromPageSource as string)
    ? fromPageSource
    : PageSources.Organic,
});

export const pageLoaded = {
  name: "page_loaded",
  attributes: {
    pageName: "page_name",
    category: "category",
  },
};

export const ctaClicked = {
  name: "cta_clicked",
  attributes: {
    pageName: "page_name",
    section: "section",
    optionSelected: "option_selected",
    position: "position",
    ctaName: "cta_name",
  },
};

export const cardClicked = {
  name: "card_clicked",
  attributes: {
    pageName: "page_name",
    section: "section",
    optionSelected: "option_selected",
    position: "position",
  },
};

export const cardViewed = {
  name: "card_viewed",
  attributes: {
    pageName: "page_name",
    section: "section",
    optionSelected: "option_selected",
    position: "position",
  },
};

export enum Pages {
  LandingPage = "Landing Page",
  Upload = "instructions page",
  SelectViolation = "violation type",
  Review = "review page",
  Confimation = "confirmation page",
  Moderation = "moderation page",
}
